import { FC } from 'react';
import LayOutPage from './layOutPage';
import LayOutPageLeft from './left';
import LayOutPageLefts, { ILayOutPageLeftsComponent } from './lefts';
import LayOutPageRight from './right';
import LayOutPageContent, { ILayOutPageContentComponent } from './content';
import LayOutPageFooter from './footer';
import LayOutPageHeader from './header';
import LayOutPageDetail from './detail';
import {
  LayOutPageProps,
  LayOutPageLeftProps,
  LayOutPageRightProps,
  LayOutPageContentProps,
  LayOutPageHeaderProps,
  LayOutPageFooterProps,
  LayOutPageDetailProps,
} from './interface';

export type ILayOutPageComponent = FC<LayOutPageProps> & {
  Left: FC<LayOutPageLeftProps>;
  Lefts: ILayOutPageLeftsComponent;
  Right: FC<LayOutPageRightProps>;
  Content: ILayOutPageContentComponent;
  Footer: FC<LayOutPageFooterProps>;
  Header: FC<LayOutPageHeaderProps>;
  Detail: FC<LayOutPageDetailProps>;
};
/** 页面布局 */
const TransLayOutPage = LayOutPage as ILayOutPageComponent;
TransLayOutPage.Left = LayOutPageLeft;
TransLayOutPage.Lefts = LayOutPageLefts;
TransLayOutPage.Right = LayOutPageRight;
TransLayOutPage.Content = LayOutPageContent;
TransLayOutPage.Footer = LayOutPageFooter;
TransLayOutPage.Header = LayOutPageHeader;
TransLayOutPage.Detail = LayOutPageDetail;

export default TransLayOutPage;
